import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import {
    CertificateModel,
    GetCertificatesResponse,
    PaginationModel,
} from "@thkStore/Store/Widgets/ExemptionCertificateList/Handlers/LoadExemptionCertificates";
import { Draft } from "immer";

export interface ExemptionCertificateListState {
    isLoading: boolean;
    certificates: CertificateModel[];
    pagination?: PaginationModel;
    currentPage: number;
    pageSize: number;
    error?: string;
    // True while the grid is auto-polling for a just-uploaded certificate to be synced
    // from Vertex into the local DB. Drives the "submitted for review / refreshing" notice.
    isAwaitingUploadSync: boolean;
}

const initialState: ExemptionCertificateListState = {
    isLoading: false,
    certificates: [],
    currentPage: 1,
    pageSize: 10,
    isAwaitingUploadSync: false,
};

const exemptionCertificateListReducer = createTypedReducerWithImmer(initialState, {
    "Widgets/ExemptionCertificateList/BeginLoadCertificates": (
        draft: Draft<ExemptionCertificateListState>,
    ) => {
        draft.isLoading = true;
        draft.error = undefined;
    },
    "Widgets/ExemptionCertificateList/CompleteLoadCertificates": (
        draft: Draft<ExemptionCertificateListState>,
        action: { result: GetCertificatesResponse },
    ) => {
        draft.isLoading = false;
        draft.certificates = action.result.certificates;
        draft.pagination = action.result.pagination;
        if (action.result.pagination) {
            draft.currentPage = action.result.pagination.page;
            draft.pageSize = action.result.pagination.pageSize;
        }
    },
    "Widgets/ExemptionCertificateList/FailLoadCertificates": (
        draft: Draft<ExemptionCertificateListState>,
        action: { error: string },
    ) => {
        draft.isLoading = false;
        draft.error = action.error;
    },
    "Widgets/ExemptionCertificateList/BeginAwaitUploadSync": (
        draft: Draft<ExemptionCertificateListState>,
    ) => {
        draft.isAwaitingUploadSync = true;
    },
    "Widgets/ExemptionCertificateList/EndAwaitUploadSync": (
        draft: Draft<ExemptionCertificateListState>,
    ) => {
        draft.isAwaitingUploadSync = false;
    },
});

(reducers as any).exemptionCertificateList = exemptionCertificateListReducer;

export type ApplicationExemptionCertificateListState = {
    exemptionCertificateList: ExemptionCertificateListState;
} & ApplicationState;
